export default __webpack_public_path__ + "static/media/icon_proffesional.1b346451.svg";